import React from 'react';
import { 
  RadarChart, 
  Radar, 
  PolarGrid, 
  PolarAngleAxis, 
  PolarRadiusAxis, 
  ResponsiveContainer,
  Tooltip
} from 'recharts';

const PerformanceChart = ({ data, themeColors }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-4 md:p-6 h-[420px]">
      <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-5">
        Performance Metrics
      </h2>
      <div className="h-[350px]">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart outerRadius={110} data={data}>
            <PolarGrid 
              stroke="#e2e8f0" 
              strokeOpacity={0.5}
              className="dark:stroke-gray-600"
            />
            <PolarAngleAxis 
              dataKey="metric" 
              tick={{
                fill: '#7f8a99',
                fontSize: 12,
                className: 'dark:fill-gray-300'
              }}
            />
            <PolarRadiusAxis 
              angle={30} 
              domain={[0, 'auto']}
              tick={{
                fill: '#475569',
                fontSize: 10,
                className: 'dark:fill-gray-300'
              }}
              className="stroke-slate-300 dark:stroke-gray-500"
            />
            <Radar
              name="Current"
              dataKey="value"
              stroke={themeColors.primary}
              fill={themeColors.primary}
              fillOpacity={0.3}
              className="dark:fill-opacity-60"
            />
            <Tooltip 
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  return (
                    <div className="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
                      <p className="font-semibold text-gray-800 dark:text-gray-200">
                        {payload[0].payload.metric}
                      </p>
                      <div className="mt-2 text-sm">
                        <p className="text-gray-600 dark:text-gray-300">
                          Value: {payload[0].value}
                        </p>
                        <p className="text-gray-600 dark:text-gray-300">
                          Max: {payload[0].payload.maxValue}
                        </p>
                      </div>
                    </div>
                  );
                }
                return null;
              }}
            />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PerformanceChart; 